import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/perimetre.png'
import _imports_1 from '@/assets/icons/perimetreSurvol.png'


const _withScopeId = n => (_pushScopeId("data-v-54aa1c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cesiumViewer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "cesiumMapContainer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "perimtreManifestation",
  class: "perimtreManifestation"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "perimtreManifestationSurvol",
  class: "perimtreManifestation"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

export function render(_ctx, _cache) {
  const _component_NavigationControls = _resolveComponent("NavigationControls")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_NavigationControls),
    _hoisted_3,
    _hoisted_4
  ]))
}